export enum ScheduleViewType {
    CALENDAR = 'calendar',
    LIST = 'list',
    SEASON = 'fullseason',
}

export enum ScheduleViewClassName {
    CALENDAR = 'calendar-container',
}
